
import { Vue, Component, Prop } from 'vue-property-decorator'
import * as T from '@/types'
import api from '@/api'
import { required, email } from 'vuelidate/lib/validators'

import AppWordmark from '@/components/app/AppWordmark.vue'
import UiToggle from '@/components/ui/inputs/UiToggle.vue'

import {
    UiButton,
    UiCard,
    UiFormattedText,
    UiModal,
    UiTextInput,
} from '@hubsolv/hubsolv-ui'

@Component({
    components: {
        AppWordmark,
        UiButton,
        UiCard,
        UiFormattedText,
        UiModal,
        UiTextInput,
    },
    validations: {
        email: {
            required,
            email,
        },
    },
})
export default class ViewPasswordResetRequestForm extends Vue {
    email: string = ''
    checkEmail: boolean = false
    loading: boolean = false

    creditorDeskImage: any = require('@/assets/creditordesk-logo-light.svg')
    hubsolvImage: any = require('@/assets/hubsolv-logo-light.svg')


    get emailErrors () {
        if (!this.$v) return null
        if (!this.$v.email.$error) return null

        const errors = []
        if (!this.$v.email.required) errors.push('Email address is required.')
        if (!this.$v.email.email) errors.push('This is not a valid email address.')
        return errors
    }

    async onSubmit () {
        if (!this.$v) return

        this.$v.$touch()

        if (this.$v.$invalid) return
        
        try {
            this.loading = true
            await api.auth.forgotPassword(this.email)
        } catch (error) {
            // Only fails if the email does not exist in the system
        } finally {
            this.checkEmail = true // Fail silently for security purposes
            this.loading = false
        }
    }
}
